import { registerBrick } from 'olympe';
import { ReactBrick, useProperty } from '@olympeio/core';
import { updateProperty } from '../../shared/datagrid/DataGridRenderers.jsx';
import { AlternativeVendorDropdown } from './AlternativeVendorDropdown.jsx';
import BCP from '../../../common/section_bcp/DM_BCP';
import React, { useEffect, useState } from 'react';
import { getApplicationContext } from '../../../common/utils/Context';
import CircularProgress from '@mui/material/CircularProgress';
import { padLeftWithZerosFinalDigits } from '../mass_import/utils.js';

export default class VendorDropDown extends ReactBrick {

    static getReactComponent($) {
        return () => {

            //get the type and bcp material parameter form the draw as a input .
            const type = useProperty($, 'type');
            const bcpMaterialData = useProperty($, 'bcpMaterialData');
            const bcpRequest = $.getProperty('bcpRequest');
            const initialValue = $.getProperty('initialValue');

            //set the BCP prop value on the basis of type for both the dropdown Alternative and MVLinked
            const property = (type == "AlternativeVendorDD") ? BCP.alternativeVendorCodeProp : BCP.mainVendorLinkedAltVendorProp;
            // set the plant and material id to passing as a props
            const [plantId, setPlantId] = useState();
            const [materialId, setmaterialId] = useState();
            const applicationContext = getApplicationContext($);
            const [disableVendor, setDisableVendor] = useState()

            useEffect(() => {
                //set the plant and material id to passing as a props
                setmaterialId(bcpMaterialData?.[0]?.materialId)
                setPlantId(bcpMaterialData?.[0]?.plantId)


            }, [bcpMaterialData?.[0]?.materialId, bcpMaterialData?.[0]?.plantId]);

            return (
                <>
                    {(plantId?.length > 0 && materialId?.length > 0) && <AlternativeVendorDropdown
                        context={$}
                        initialValue={""}
                        bcpRequest={bcpRequest}
                        onChange={(newVendor) => {
                            <CircularProgress size={60} color="secondary" />;
                            const vendorVal = newVendor?.value?.slice(0, newVendor.value.indexOf('-')) || null
                            const setApplicationContextKey = (type === "AlternativeVendorDD") ? "alternativeVsCode" : "mvLinkedCode"
                            applicationContext.set(setApplicationContextKey, padLeftWithZerosFinalDigits(vendorVal, 10))
                        }}
                        property={property}
                        type={type}
                        disabled={false}
                        fromDataGrid={false}
                        plantId={plantId}
                        materialId={materialId}
                        setDisableVendor={setDisableVendor}
                    />}
                </>

            );
        };
    }
}

registerBrick('0198c722720832a85025', VendorDropDown);